import sanitizeHtmlLib from 'sanitize-html';


export const sanitizeHtml = (html: string): string => {
    return sanitizeHtmlLib(html, {
        allowedTags: sanitizeHtmlLib.defaults.allowedTags.concat(['img', 'pre']),
        allowedAttributes: {
            ...sanitizeHtmlLib.defaults.allowedAttributes,
            img: ['class', 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading', 'style'],
            strong: ['style'],
            p: ['style'],
            pre: ['data-language'],
            a: ['style', 'href'],
            u: ['style']
        },
        disallowedTagsMode: "escape",
        selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
        allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel', 'data'],
    });
}